const listeners = new Set()

export const onBrandingUpdate = (callback) => {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

export const notifyBrandingUpdated = () => {
  listeners.forEach((cb) => cb())
}
